<script>
import ModalOptionsToggleButton from "@/components/ModalOptionsToggleButton";
import ModalWrapperOptions from "@/components/modals/options/ModalWrapperOptions";

export default {
  name: "InfoDisplayOptionsModal",
  components: {
    ModalOptionsToggleButton,
    ModalWrapperOptions,
  },
  data() {
    return {
      infinityUnlocked: false,
      eternityUnlocked: false,
      realityUnlocked: false,
      alchemyUnlocked: false,
      atomUnlocked: false,

      showPercentage: false,
      achievements: false,
      achievementUnlockStates: false,
      challenges: false,
      studies: false,
      glyphEffectDots: false,
      realityUpgrades: false,
      perks: false,
      alchemy: false,
      atomUpgrades: false,
    };
  },
  computed: {
    fullCompletion() {
      return player.records.fullGameCompletions > 0;
    },
  },
  watch: {
    showPercentage(newValue) {
      player.options.showHintText.showPercentage = newValue;
    },
    achievements(newValue) {
      player.options.showHintText.achievements = newValue;
    },
    achievementUnlockStates(newValue) {
      player.options.showHintText.achievementUnlockStates = newValue;
    },
    challenges(newValue) {
      player.options.showHintText.challenges = newValue;
    },
    studies(newValue) {
      player.options.showHintText.studies = newValue;
    },
    glyphEffectDots(newValue) {
      player.options.showHintText.glyphEffectDots = newValue;
    },
    realityUpgrades(newValue) {
      player.options.showHintText.realityUpgrades = newValue;
    },
    perks(newValue) {
      player.options.showHintText.perks = newValue;
    },
    alchemy(newValue) {
      player.options.showHintText.alchemy = newValue;
    },
    atomUpgrades(newValue) {
      player.options.showHintText.atomUpgrades = newValue;
    },
  },
  methods: {
    update() {
      const progress = PlayerProgress.current;
      this.infinityUnlocked = this.fullCompletion || progress.isInfinityUnlocked;
      this.eternityUnlocked = this.fullCompletion || progress.isEternityUnlocked;
      this.realityUnlocked = this.fullCompletion || progress.isRealityUnlocked;
      this.alchemyUnlocked = this.fullCompletion || Ra.unlocks.effarigUnlock.canBeApplied;
      this.atomUnlocked = this.fullCompletion || progress.isAtomUnlocked;

      const options = player.options.showHintText;
      this.showPercentage = options.showPercentage;
      this.achievements = options.achievements;
      this.achievementUnlockStates = options.achievementUnlockStates;
      this.challenges = options.challenges;
      this.studies = options.studies;
      this.glyphEffectDots = options.glyphEffectDots;
      this.realityUpgrades = options.realityUpgrades;
      this.perks = options.perks;
      this.alchemy = options.alchemy;
      this.atomUpgrades = options.atomUpgrades;
    },
  },
};
</script>

<template>
  <ModalWrapperOptions class="c-modal-options__large">
    <template #header> Info Display Options </template>
    <div class="c-modal-options__button-container">
      <ModalOptionsToggleButton v-model="showPercentage" text="Show % gain:" />
      <ModalOptionsToggleButton v-model="achievements" text="Achievement IDs:" />
      <ModalOptionsToggleButton v-model="achievementUnlockStates" text="Achievement unlock state indicators:" />
      <ModalOptionsToggleButton v-if="infinityUnlocked" v-model="challenges" text="Challenge IDs:" />
      <ModalOptionsToggleButton v-if="eternityUnlocked" v-model="studies" text="Time Study IDs:" />
      <ModalOptionsToggleButton v-if="realityUnlocked" v-model="glyphEffectDots" text="Glyph effect dots:" />
      <ModalOptionsToggleButton v-if="realityUnlocked" v-model="realityUpgrades" text="Reality Upgrade names:" />
      <ModalOptionsToggleButton v-if="realityUnlocked" v-model="perks" text="Perk IDs:" />
      <ModalOptionsToggleButton v-if="alchemyUnlocked" v-model="alchemy" text="Alchemy resource amounts:" />
      <ModalOptionsToggleButton v-if="atomUnlocked" v-model="atomUpgrades" text="Atom Upgrade names:" />
    </div>
    Note: All types of additional info above will always display when holding shift.
  </ModalWrapperOptions>
</template>
